import htmlComponent from 'htmlcomponent';
import { contaoService } from '@/service/index'
import { config } from '@/config'

htmlComponent.listen('cookie:consent', (e, data) => {
  try {
    contaoService.sendConsentLog({ consent: data, brand: config.BRAND })
  } catch(err) {
    // don't do anything for now
  }
})
